const styles = {
  presale: {
    marginTop: "5px",
    marginBottom: "5px",
    backgroundColor: "#035AA5",
    borderRadius: "5px",
    color: "white",
    //cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
  },
  presale1: {
    marginTop: "10px",
    marginBottom: "5px",
    backgroundColor: "#035AA5",
    borderRadius: "5px",
    color: "white",
    //cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
  },
  details: {
    marginTop: "5px",
    marginBottom: "5px",
    backgroundColor: "red",
    borderRadius: "5px",
    color: "white",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
  },
  details2: {
    marginTop: "5px",
    marginBottom: "5px",
    backgroundColor: "orange",
    borderRadius: "5px",
    color: "black",
    cursor: "pointer",
    fontWeight: "bold",
    padding: "5px 10px",
    textAlign: "center",
    transition: "200ms",
    width: "100%",
    boxSizing: "border-box",
    border: "0",
    fontSize: "14px",
    userSelect: "none",
  },
};

function DetailsLink() {
  window.open(
    "https://destinydao.medium.com/destiny-nft-lottery-giveaway-2b238c1af3f3",
    "_blank",
  );
}
function WhitelistLink() {
  window.open("https://forms.gle/1WN55yMc8sza5TeT6", "_blank");
}
function GiveAwayLink() {
  window.open(
    "https://twitter.com/Destiny_Finance/status/1505945428373778435",
    "_blank",
  );
}
function PresaleDetail() {
  return (
    <div>
      <button
        style={styles.presale1}
        //disabled={!info.connected || mintInfo.cost == "0"}
      >
        Presale Round One PRICE : 0.20 BNB
      </button>
      <button
        style={styles.presale}
        //disabled={!info.connected || mintInfo.cost == "0"}
      >
        Presale Round Two PRICE : 0.23 BNB
      </button>
      <button
        style={styles.presale}
        // disabled={!info.connected || mintInfo.cost == "0"}
        className="button"
      >
        Public Sale PRICE : 0.25 BNB
      </button>
      <button
        style={styles.details}
        // disabled={!info.connected || mintInfo.cost == "0"}
        onClick={() => DetailsLink()}
      >
        Read Full Details
      </button>
      <button
        style={styles.details2}
        // disabled={!info.connected || mintInfo.cost == "0"}
        className="button"
        onClick={() => WhitelistLink()}
      >
        Get Whitelisted
      </button>
      <button
        style={styles.details2}
        // disabled={!info.connected || mintInfo.cost == "0"}
        className="button"
        onClick={() => GiveAwayLink()}
      >
        Participate in Giveaway
      </button>
    </div>
  );
}

export default PresaleDetail;
